'use strict';

var angular = require('angular');
var GridMarketAnalysisReoptPopoverDirective = function GridMarketAnalysisReoptPopoverDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmGridDateReoptPreviewButton',
    template: require('../templates/grid-market-analysis-reopt-popover.html'),
    link: function link($scope) {
      $scope.dropDownClicked = function (e) {
        e.stopPropagation();
        if (angular.element(e.target).hasClass('cancel-drop-down')) {
          angular.element('.toolbar-dropdown-menu').parent().removeClass('open');
        }
      };
    }
  };
};
GridMarketAnalysisReoptPopoverDirective.$inject = [];
module.exports = GridMarketAnalysisReoptPopoverDirective;